module.exports = __webpack_public_path__ + "media/images/icons/pencil-2c84f59ae01b44d7be9f746d183effcd.svg";